import ModalPortal from "components/modal/ModalPortal"
import Button from "../button/Button"
import If from "../If"
import Translate from "../Translate"
import './ConfirmationModal.scss';
import useAppContext from "utilities/hooks/useAppContext"

export type ConfirmationModalPropsType = {
    title?: string,
    text: string,
    confirmationText?: string,
    rejectText?: string,
    onConfirm: ((data: any, e: React.MouseEvent) => void) | ((data: any, e: React.MouseEvent) => Promise<void>)
    onReject?: ((e: React.MouseEvent) => void) | boolean,
    name: string
}

const ConfirmationModal = (props: ConfirmationModalPropsType) => {
    const context = useAppContext();

    const onConfirm = (e: React.MouseEvent) => {
        if (typeof props.onConfirm == 'function') props.onConfirm(context.modal.getData(props.name), e);
        else context.navigate(-1);
    }

    const onReject = (e: React.MouseEvent) => {
        if (typeof props.onReject == 'function') props.onReject(e);
        else context.navigate(-1);
    }

    return (
        <ModalPortal name={props.name} title={props.title || context.t('common.confirmation')}>
            <div className="confirmation-modal">
                <div className="message">
                    <span><Translate i18nKey={props.text} /></span>
                </div>
                <div className="actions">
                    <If condition={props.onConfirm !== undefined}>
                        <Button theme="primary" title="submit" onClick={onConfirm}>
                            <Translate i18nKey={props.confirmationText || 'common.yes'} />
                        </Button>
                    </If>
                    <If condition={props.onReject !== undefined && props.onReject !== false}>
                        <Button title="submit" onClick={onReject}>
                            <Translate i18nKey={props.rejectText || 'common.no'} />
                        </Button>
                    </If>
                </div>
            </div>
        </ModalPortal>
    );
};

export default ConfirmationModal;
